// removed by extract-text-webpack-plugin
module.exports = {"propertyPlaceholder":"b_cDcnomR3uEIFWzV6Fus","mobile":"_3IpGtXKWzGUOW4Vge_HgOh","galleryPlaceholder":"_2O4LAE24saTW4MImVV2kq9","mainInfo":"_3A7c88cRPuIwf44Z4DKkp7","propertyInfo":"_2vHOpJjaEoq_VYNG4TTM_o","propertyType":"_2Z7ok2YcoonzL8jSq4FagM","propertySummary":"_12EmtyD_hRdql6SA00l4dn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailsPlaceholder/PropertyDetailsPlaceholder.scss
// module id = 1732
// module chunks = 0